import { UserOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Switch,
  Table,
  Tag,
} from "antd";
import { CurrencyApi, OrganisationProfileAPI } from "../../../../api";

import axios from "axios";
import { connect } from "react-redux";
import { H5, Image } from "../../../../AbstractElements";

import React, { useEffect, useRef, useState } from "react";
import { PlusCircle } from "react-feather";
import { toast } from "react-toastify";
import { CardBody } from "reactstrap";
import { OrganisationBranchApi } from "../../../../api";
import {
  downloadPoBudgetData,
  fetchOrganisationDetails,
} from "../../../../api/organisation.api";
import { LogEvents, LoggerContext } from "../../../../context/logging";
import { organisationEditGranted } from "../../../../utils/PermissionFunctions/userPermissions";
import { useAPIUser } from "../../../../_helper/User/UserProvider";

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});

const Branches = (props) => {
  const logger = React.useContext(LoggerContext);

  const imgInputRef = useRef();
  const currentDate = new Date();
  const formRef = useRef();
  const formRefOrg = useRef();
  const { Option } = Select;
  const [image, setImage] = useState();
  const [branches, setBranches] = useState([]);
  const [updateOrganisationLogo, setUpdateOrganisationLogo] = useState();
  const [currency, setCurrency] = useState([]);
  const [modal1Visible, setModal1Visible] = useState(false);
  const [modalEditVisible, setModalEditVisible] = useState(false);
  const { userDetails, setUserDetails } = useAPIUser();
  const [branch, setBranch] = useState(null);
  const [initials, setInitials] = useState("YYYY");
  const [poInitials, setPoInitials] = useState("YYYY");
  const [estimateDateInitials, setEstimateDateInitials] = useState("YYYY");
  const [inventoryDateInitials, setInventoryDateInitials] = useState("YYYY");
  const [branchSignature, setBranchSignature] = useState();
  const [branchQR, setBranchQR] = useState();
  const [orgId, setOrgId] = useState();
  const [drawerTitle, setDrawerTitle] = useState("Add branch");
  const [projectCodeInitials, setProjectCodeInitials] = useState("PRO");
  const [poNumberInitials, setPoNumberInitials] = useState("PO");
  const [estimateInitials, setEstimateInitials] = useState("Q");
  const [inventoryInitials, setInventoryInitials] = useState("INV");
  const [unsaved, setUnsaved] = useState(false);

  const initalOptions = [
    {
      label: "YYYY",
      value: currentDate.getFullYear().toString(),
    },
    {
      label: "MM-YYYY",
      value:
        (currentDate.getMonth() + 1 <= 9
          ? "0" + (currentDate.getMonth() + 1)
          : currentDate.getMonth() + 1) +
        "-" +
        currentDate.getFullYear(),
    },
    {
      label: "YYYYYY",
      value:
        currentDate.getFullYear().toString() +
        currentDate.getFullYear().toString().substring(2),
    },
    {
      label: "MM-YY",
      value:
        (currentDate.getMonth() + 1 <= 9
          ? "0" + (currentDate.getMonth() + 1)
          : currentDate.getMonth() + 1) +
        "-" +
        currentDate.getFullYear().toString().substring(2),
    },
    {
      label: "YY",
      value: currentDate.getFullYear().toString().substring(2),
    },
  ];
  const selectInitials = (
    <Select
      defaultValue={"YYYY"}
      onChange={(e) => {
        setInitials(e);
      }}
    >
      {initalOptions.map((each, i) => (
        <Option key={i} value={each.label}>
          {each.label}
        </Option>
      ))}
    </Select>
  );

  const currencyOptions = currency?.map((each) => (
    <Option key={each?.id} value={each?.id}>
      {each?.name} | {each?.symbol}
    </Option>
  ));
  const selectPoInitials = (
    <Select
      defaultValue={"YYYY"}
      value={poInitials}
      onChange={(e) => {
        setPoInitials(e);
      }}
    >
      {initalOptions.map((each, i) => (
        <Option key={i} value={each.label}>
          {each.label}
        </Option>
      ))}
    </Select>
  );
  const selectEstimateInitials = (
    <Select
      defaultValue={"YYYY"}
      value={estimateDateInitials}
      onChange={(e) => {
        setEstimateDateInitials(e);
      }}
    >
      {initalOptions.map((each, i) => (
        <Option key={i} value={each.label}>
          {each.label}
        </Option>
      ))}
    </Select>
  );
  const selectInventoryInitials = (
    <Select
      defaultValue={"YYYY"}
      value={inventoryDateInitials}
      onChange={(e) => {
        setInventoryDateInitials(e);
      }}
    >
      {initalOptions.map((each, i) => (
        <Option key={i} value={each.label}>
          {each.label}
        </Option>
      ))}
    </Select>
  );

  const columns = [
    {
      title: "Name",
      key: "name",
      render: (data) => <span>{data?.branch_name}</span>,
    },
    {
      title: "Address",
      key: "address",
      render: (data) => <span>{data?.address}</span>,
    },
    // {
    //   title: "Branch Head Designation",
    //   key: "headDesignation",
    //   render: (data) => <span>{data?.branch_head_designation}</span>,
    // },
    // {
    //   title: "Branch Head Name",
    //   key: "department",
    //   render: (data) => <span>{data?.branch_head_name}</span>,
    // },
    {
      title: "Active",
      key: "status",
      render: (data) => {
        return (
          <Switch
            checked={data.status ? true : false}
            onChange={() => onToggleStatus(data.id, data.status)}
          />
        );
      },
    },
    {
      title: "Po Number Initials",
      key: "poNumberInitials",
      render: (data) => {
        return (
          <>
            {data?.po_number_initials}-{data?.po_number_format}
          </>
        );
      },
    },
    {
      title: "Project Code Initials",
      key: "projectCodeInititals",
      render: (data) => {
        return (
          <>
            {data?.project_code_initials}-{data?.project_code_format} (
            {data?.project_code_initials ?? ""}-
            {getExampleDateFrom({ format: data?.project_code_format })}-
            {data?.po_counter})
          </>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (data, index) => (
        <Space>
          <Tag
            style={{ cursor: "pointer" }}
            color="purple"
            onClick={() => {
              if (organisationEditGranted(props.settings?.user)) {
                EditDetailsClicked(data);
              } else {
                toast.info(
                  "You do not have the access to perform this action."
                );
              }
            }}
          >
            Edit Details
          </Tag>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    fetchBranches();
    fetchCurrency();
  }, []);

  useEffect(() => {
    if (formRefOrg.current !== null) {
      getOrganisationDetails();
    }
  }, [formRefOrg]);
  const getOrganisationDetails = () => {
    fetchOrganisationDetails().then((res) => {
      formRefOrg?.current?.setFieldsValue({
        name: res?.name,
        short_name: res?.short_name ?? "",
        pan_number: res?.pan_number ?? "",
        address: res?.address ?? "",
        currency: res?.currency ?? 1,
        city: res?.city ?? "",
        project_code_initials: res?.project_code_initials ?? "",
        po_number_initials: res?.po_number_initials ?? "",
        pincode: res?.pincode ?? "",
      });
      setImage(res?.organisation_logo);
    });
  };
  const fetchBranches = () => {
    const { dispatch } = props;
    axios.get(`${OrganisationBranchApi}`).then((res) => {
      setBranches(res?.data);
      dispatch({
        type: "settings/CHANGE_SETTING",
        payload: {
          setting: "all_branches",
          value: res?.data,
        },
      });
    });
  };
  const fetchCurrency = () => {
    axios
      .get(`${CurrencyApi}`)
      .then((res) => {
        setCurrency(res.data);
      })
      .catch(() => {});
  };
  const addBranch = (values) => {
    console.log(values);
    logger.log(LogEvents.submitOrganizationBranch, {});

    const payload = new FormData();
    payload.append("branch_name", values.branch_name);
    payload.append("pincode", values.pincode);
    payload.append(
      "branch_head_name",
      values.branch_head_name ? values.branch_head_name : ""
    );
    payload.append("currency", values.currency ? values.currency : 1);
    payload.append("organisation", userDetails?.organisation?.organisation_id);
    payload.append(
      "branch_head_designation",
      values.branch_head_designation ? values.branch_head_designation : ""
    );
    payload.append("address", values.address ? values.address : "");
    payload.append("status", true);

    payload.append("project_code_initials", projectCodeInitials ?? "");
    payload.append("po_number_initials", poNumberInitials ?? "");
    payload.append("estimate_number_initials", estimateInitials ?? "");
    payload.append("inventory_number_initials", inventoryInitials ?? "");

    payload.append("project_code_format", initials ?? "YYYY");
    payload.append("po_number_format", poInitials ?? "YYYY");
    payload.append("estimate_number_format", estimateDateInitials ?? "YYYY");
    payload.append("inventory_number_format", inventoryDateInitials ?? "YYYY");

    payload.append("bank_account_number", values?.bank_account_number);
    payload.append("branch_upi", values?.branch_upi);
    payload.append("bank_ifsc", values?.bank_ifsc);

    if (branchSignature) {
      payload.append("branch_head_signature", branchSignature);
    }
    if (branchQR) {
      payload.append("qr_code", branchQR);
    }
    if (branch) {
      axios
        .put(`${OrganisationBranchApi}${branch?.id}/`, payload)
        .then((res) => {
          console.log("branch added", res);
          message.success("Branch updated succesfully");
          fetchBranches();
          setBranch("");
          setModal1Visible(false);
          formRef.current.resetFields();
          setDefaultValues();
        });
    } else {
      axios.post(`${OrganisationBranchApi}`, payload).then((res) => {
        console.log("branch added", res);
        message.success("New branch added succesfully");
        fetchBranches();
        setDefaultValues();
        setModal1Visible(false);
        formRef.current.resetFields();
      });
    }
  };

  const setDefaultValues = () => {
    setInitials("YYYY");
    setPoInitials("YYYY");
    setProjectCodeInitials("PRO");
    setPoNumberInitials("PO");
  };
  const EditDetailsClicked = (data) => {
    setBranch(data);
    setInitials(data?.project_code_format);
    setPoInitials(data?.po_number_format);
    setProjectCodeInitials(data?.project_code_initials);
    setPoNumberInitials(data?.po_number_initials);
    setDrawerTitle("Edit branch");
    var branchDetails = data;
    setModal1Visible(true);
    setTimeout(() => {
      if (branchDetails) {
        formRef.current.setFieldsValue({
          branch_name: branchDetails?.branch_name,
          branch_head_name: branchDetails?.branch_head_name,
          branch_head_designation: branchDetails?.branch_head_designation,
          address: branchDetails?.address,
          currency: branchDetails?.currency,
          po_number_format: branchDetails?.po_number_format,
          project_code_format: branchDetails?.project_code_format,
          estimate_number_format: branchDetails?.estimate_number_format,
          inventory_number_format: branchDetails?.inventory_number_format,
          project_code_initials: branchDetails?.project_code_initials,
          po_number_initials: branchDetails?.po_number_initials,
          estimate_number_initials: branchDetails?.estimate_number_initials,
          inventory_number_initials: branchDetails?.inventory_number_initials,
          branch_upi: branchDetails?.branch_upi,
          bank_account_number: branchDetails?.bank_account_number,
          bank_ifsc: branchDetails?.bank_ifsc,
        });
      }
    }, 300);
  };

  const getExampleDateFrom = ({ format }) => {
    const date = initalOptions.find((option) => {
      return option.label == format;
    });
    return date?.value;
  };
  const onToggleStatus = (id, status) => {
    if (organisationEditGranted(props.settings?.user)) {
      const value = { status: status ? false : true };
      axios.put(`${OrganisationBranchApi}${id}/`, value).then((res) => {
        toast.success(`Status Updated Successfully!`);
        fetchBranches();
      });
    } else {
      toast.info("You do not have the access to perform this action.");
    }
  };
  const currencyOption = currency?.map((each) => (
    <Option key={each.id} value={each.id}>
      {each.name}
      {` ( ${each.symbol} )`}
    </Option>
  ));

  const downloadAllPOItemData = () => {
    logger.log(LogEvents.downloadAllPoWoData, {});
    if (organisationEditGranted(props.settings?.user)) {
      downloadPoBudgetData({ branch: props?.settings?.branch?.id });
    } else {
      toast.info("You do not have the access to perform this action.");
    }
  };

  const saveChanges = () => {
    if (organisationEditGranted(props.settings?.user)) {
      const updatedValues = formRefOrg.current.getFieldsValue();
      console.log("updatedValues", updatedValues);
      if (updatedValues.name?.length > 0) {
        const values = new FormData();
        values.append("name", updatedValues.name);
        values.append("short_name", updatedValues.short_name ?? "");
        values.append("pan_number", updatedValues.pan_number ?? "");
        values.append("city", updatedValues.city ?? "");
        values.append("address", updatedValues.address ?? "");
        values.append("currency", updatedValues.currency ?? 1);
        values.append("project_code_initials", projectCodeInitials ?? "");
        values.append("po_number_initials", poNumberInitials ?? "");
        values.append("estimate_number_initials", estimateInitials ?? "Q");
        values.append("inventory_number_initials", inventoryInitials ?? "INV");
        values.append("estimate_number_format", estimateDateInitials ?? "YYYY");
        values.append(
          "inventory_number_format",
          inventoryDateInitials ?? "YYYY"
        );

        values.append("pincode", updatedValues.pincode);
        if (updateOrganisationLogo) {
          values.append("organisation_logo", updateOrganisationLogo);
        }
        axios
          .put(`${OrganisationProfileAPI}`, values)
          .then((res) => {
            toast.success("Changes Saved!");
            getOrganisationDetails();
            setUnsaved(false);
          })
          .catch((res) => {});
      } else {
        console.log(projectCodeInitials);
        console.log(poNumberInitials);
        console.log(currency);
        toast.error("Enter all fields!");
      }
    } else {
      toast.info("You do not have the access to perform this action.");
    }
    logger.log(LogEvents.saveOrganizationChanges, {});
  };
  return (
    <React.Fragment>
      <CardBody>
        <H5>Organisation Details</H5>
        <div className="d-flex" style={{ alignItems: "center" }}>
          {image ? (
            <Image
              attrImage={{
                className: "img-100 rounded-circle",
                alt: "",
                src: `${image}`,
                style: { cursor: "pointer" },
                onClick: () => {
                  if (imgInputRef.current) {
                    imgInputRef.current.click();
                  }
                },
              }}
            />
          ) : (
            <div
              className="img-100 rounded-circle"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #000",
                cursor: "pointer",
              }}
              onClick={() => {
                if (imgInputRef.current) {
                  imgInputRef.current.click();
                }
              }}
            >
              <UserOutlined style={{ fontSize: "60px" }} />
            </div>
          )}
          <input
            type="file"
            accept="image/jpg,image/jpeg,image/png"
            onChange={(e) => {
              setUpdateOrganisationLogo(e.target.files[0]);
            }}
            style={{ width: 1, height: 1, opacity: 0, overflow: "hidden" }}
            ref={imgInputRef}
          />
          {unsaved && <span style={{ color: "red" }}>Unsaved changes.</span>}
        </div>
        <Form
          layout="vertical"
          id="organisationProfileForm"
          ref={formRefOrg}
          // onFinish={saveChanges}
        >
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"name"}
                label="Name"
                rules={[
                  {
                    required: true,
                    message: "Name is required",
                  },
                ]}
              >
                <Input placeholder="Name" />
              </Form.Item>
            </Col>

            <Col sm={12}>
              <Form.Item
                name={"city"}
                label="City"
                rules={[
                  {
                    pattern: /^[A-Za-z]+[A-Za-z ]*$/,
                    message: "Enter valid City",
                  },
                ]}
              >
                <Input placeholder="Enter city" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col>
              <Space className="mb-0">
                <Button
                  // htmlType="submit"
                  form="organisationProfileForm"
                  onClick={saveChanges}
                >
                  {"Save Changes"}
                </Button>
                {/* <Button
                  onClick={() => {
                    setPoNumberInitials(0);
                  }}
                >
                  {"Reset PO Number to zero"}
                </Button> */}
                <Button
                  onClick={() => {
                    downloadAllPOItemData();
                  }}
                >
                  {"Download all Po/Wo data"}
                </Button>
                {/* <Button
                  onClick={() => {
                    setProjectCodeInitials(0);
                  }}
                >
                  {"Reset All Project Codes"}
                </Button> */}
              </Space>
            </Col>
          </Row>
        </Form>
        <div className="d-flex justify-content-between align-items-center">
          <div className="">
            <H5>Branches</H5>
          </div>
          {organisationEditGranted(props.settings?.user) && (
            <Button
              className="btn btn-primary d-flex align-items-center"
              style={{ color: "white", margin: 8 }}
              onClick={() => {
                logger.log(LogEvents.addOrganizationBranch, {});
                if (organisationEditGranted(props.settings?.user)) {
                  setDrawerTitle("Add branch");
                  setDefaultValues();
                  setBranch(null);
                  setModal1Visible(true);
                } else {
                  toast.info(
                    "You do not have the access to perform this action."
                  );
                }
              }}
            >
              {" "}
              <PlusCircle />
              <div style={{ marginLeft: "4px" }}>Add Branch</div>
            </Button>
          )}
        </div>

        <Table
          columns={columns}
          dataSource={branches}
          scroll={{ x: "max-content" }}
        />
      </CardBody>
      <Drawer
        title={drawerTitle}
        centered
        placement="right"
        size="large"
        visible={modal1Visible}
        onClose={() => {
          formRef.current.resetFields();
          setModal1Visible(false);
        }}
        footer={[
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {" "}
            <Button
              key="back"
              onClick={() => {
                formRef.current.resetFields();
                setModal1Visible(false);
              }}
            >
              Cancel
            </Button>
            <Button
              key="submit"
              className="btn btn-primary text-white"
              htmlType="submit"
              // loading={loading}
              form="branchForm"
              // onClick={() => {
              //   addStep();
              // }}
            >
              Submit
            </Button>
          </div>,
        ]}
      >
        <Form
          layout="vertical"
          id="branchForm"
          ref={formRef}
          onFinish={addBranch}
        >
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item
                name={"branch_name"}
                label="Branch name"
                rules={[
                  {
                    required: true,
                    message: "Name is required",
                  },
                ]}
              >
                <Input className="w-100" placeholder="Branch name" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item name={"address"} label="Address">
                <Input
                  className="w-100"
                  placeholder="Enter your branch address here"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col sm={12}>
              {/* <Form.Item name={"address"} label="Address">
                <Input placeholder="Enter Address" />
              </Form.Item> */}

              <Form.Item name={"currency"} label="Currency" required="true">
                <Select placeholder="Select Currency">{currencyOptions}</Select>
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"pincode"}
                label="Pincode"
                rules={[
                  {
                    pattern: /^[0-9]{6}$/,
                    message: "Enter a valid six digit pin code",
                  },
                ]}
              >
                <Input placeholder="Enter Pincode" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"bank_account_number"} label="Bank account">
                <Input placeholder="Enter Bank account" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item name={"bank_ifsc"} label="Ifsc code">
                <Input placeholder="Enter IFSC" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"branch_upi"} label="UPI">
                <Input placeholder="Enter UPI" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item name={"branch_head_signature"} label="Branch Logo">
                <Input
                  type="file"
                  accept="image/jpg,image/jpeg,image/png"
                  onChange={(e) => {
                    setBranchSignature(e.target.files[0]);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"project_code_initials"}
                label={`Project Code Initials: (${projectCodeInitials ?? "PRO"}-
                ${getExampleDateFrom({ format: initials })})`}
                rules={[
                  {
                    required: true,
                    message: "Project code is required",
                  },
                ]}
              >
                <Input
                  addonAfter={selectInitials}
                  defaultValue={projectCodeInitials}
                  onChange={(e) => {
                    setProjectCodeInitials(e.target.value);
                  }}
                  value={projectCodeInitials}
                />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"po_number_initials"}
                label={`PO Number Initials: (${
                  poNumberInitials ?? ""
                }-${getExampleDateFrom({ format: poInitials })}${
                  "-" + (branch?.po_counter ?? 0) ?? 0
                })`}
                rules={[
                  {
                    required: true,
                    message: "PO Number is required",
                  },
                ]}
              >
                <Input
                  defaultValue={poNumberInitials}
                  value={poNumberInitials}
                  addonAfter={selectPoInitials}
                  onChange={(e) => {
                    setPoNumberInitials(e.target.value);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"estimate_number_initials"}
                label={`Pro Forma Initials: (${
                  estimateInitials ?? ""
                }-${getExampleDateFrom({ format: estimateDateInitials })}${
                  "-" + (branch?.estimate_counter ?? 0)
                })`}
                rules={[
                  {
                    required: true,
                    message: "Pro Forma initials is required",
                  },
                ]}
              >
                <Input
                  addonAfter={selectEstimateInitials}
                  defaultValue={estimateInitials}
                  onChange={(e) => {
                    setEstimateInitials(e.target.value);
                  }}
                  value={estimateInitials}
                />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"inventory_number_initials"}
                label={`Inventory Number Initials: (${
                  inventoryInitials ?? ""
                }-${getExampleDateFrom({ format: inventoryDateInitials })}${
                  "-" + (branch?.inventory_counter ?? 0) ?? 0
                })`}
                rules={[
                  {
                    required: true,
                    message: "Inventoy intials is required",
                  },
                ]}
              >
                <Input
                  defaultValue={inventoryInitials}
                  value={inventoryInitials}
                  addonAfter={selectInventoryInitials}
                  onChange={(e) => {
                    setInventoryInitials(e.target.value);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"qr_code"} label="Branch QR Code">
                <Input
                  type="file"
                  accept="image/jpg,image/jpeg,image/png"
                  onChange={(e) => {
                    setBranchQR(e.target.files[0]);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(Branches);
